import { PropTypes } from 'prop-types';
import { PropTypes as ZPropTypes } from 'z-react-components';

export const auth = PropTypes.shape({
    isLoggedIn: PropTypes.bool.isRequired,
    isResumingLogin: PropTypes.bool.isRequired,
    isLoggingIn: PropTypes.bool.isRequired,
    loginError: PropTypes.object,
    user: ZPropTypes.user
});

export const exercise = PropTypes.shape({
    audioNodeId: PropTypes.number,
    audioXml: PropTypes.string,
    book: PropTypes.object,
    contextId: PropTypes.number,
    id: PropTypes.number,
    isPreviewOpen: PropTypes.bool,
    sharedtextNodeId: PropTypes.number,
    sharedTextXml: PropTypes.string,
    subject: PropTypes.object,
    taxonomy: PropTypes.array,
    title: PropTypes.string,
    type: PropTypes.object,
    xml: PropTypes.string
});
